<template>
  <div>
    <Showcase :key="current" v-if="! run" :config="workouts[current]" v-on:end="showcaseEnd" v-on:menu="showMenu" />
    <Workout :key="current" v-if="run" :config="workouts[current]" :workoutsNumber="workouts.length" :currentWorkout="current" :workoutLen="workoutLen" :currentTime="currentTime" v-on:end="workoutEnd" v-on:menu="showMenu" />
    <WorkoutMenu ref="menu" :show="false" v-on:resume="resume"  v-on:save="save"  v-on:stop="stop" />
  </div>
</template>

<script>
import Workout from '@/components/Settings/Workout'
import Showcase from '@/components/Settings/Showcase'
import WorkoutMenu from '@/components/Settings/WorkoutMenu'

export default {
  name: 'TrainingFlow',
  data () {
    let days = 1 + this.$store.getters.getTrainingDays % 3
    let workouts = this.$store.getters.getWarmup.concat(this.$store.getters.getNWorkouts(1 + 2 * days), this.$store.getters.getCooldown)
    return {
      run: false,
      workouts,
      time: 0,
      workoutLen: workouts.reduce((i, w) => {
          i += w.break * w.repetitions.length
          i += w.repetitions.reduce((s,e) => s+e, 0)
          return i
        }, 0)
    }
  },
  computed: {
    currentConfig () {
      return this.workouts[this.current]
    },

    current() {
      return this.$store.getters.getTrainingState.current
    },
    currentTime () {
      return this.workouts.reduce((i, w, c) => {
          if (c < this.current) {
            i += w.break * w.repetitions.length
            i += w.repetitions.reduce((s,e) => s+e, 0)
          }
          return i
        }, 0)
    }
  },
  methods: {
    showcaseEnd () {
      if (this.current < this.workouts.length - 1) {
        this.run = true
      } else {
        this.$store.commit('setWorkoutNumber', 0)
        this.$router.push({ name: 'TrainingEnd' })
      }
    },
    workoutEnd () {
      if (this.current < this.workouts.length - 1) {
        this.time = 0
        this.run = false
        this.$store.commit('setWorkoutNumber', this.current + 1)
      } else {
        this.$store.commit('setWorkoutNumber', 0)
        this.$router.push({ name: 'TrainingEnd' })
      }
    },
    resume() {
      if (this.run === true) {
        //this.$refs.vid.playPause()
      }
    },
    save() {
      this.$router.push({ name: 'Home' })
    },
    stop() {
      this.$store.commit('setWorkoutNumber', 0)
      this.$router.push({ name: 'Home' })
    },
    showMenu() {
      this.$refs.menu.showMe()
    }
  },
  components: {
    Workout,
    WorkoutMenu,
    Showcase
  }
}
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/Settings/TrainingFlow.vue